module.exports = __webpack_public_path__ + "static/media/microsoft.48a1d566.svg";